import { Callout } from '@shinetools/lumen-react'
import { useTranslation } from 'react-i18next'

import { useOrgUsesReceiptsOnly } from '../../../../hooks/useOrgUsesReceiptsOnly'
import { EInvoiceStatus } from '../../constants'

export const EInvoicingCashedBanner = ({
  status,
  messageKey,
}: {
  status: EInvoiceStatus | null
  messageKey?: string
}) => {
  const { t } = useTranslation()

  // Naming is likely a bit confusing, but it means
  // the org is in auto-forward mode (today means
  // isCegid=1 and auto-forward setting is ON)
  const orgUsesReceiptsOnly = useOrgUsesReceiptsOnly()

  if (status !== EInvoiceStatus.PaymentReceived) {
    return
  }

  const defaultTranslationKey = orgUsesReceiptsOnly
    ? 'receipts.e_invoice.status.payment_marked_paid_banner_message_cpa_org'
    : 'receipts.e_invoice.status.payment_marked_paid_banner_message'

  return <Callout color="informative" message={t(messageKey ?? defaultTranslationKey)} />
}
